import { url } from "../../../url";
import { edit } from "../actions";

const updateTodoText = (todoId, text) => {
    return async (dispatch) => {
        const response = await fetch(`${url}/${todoId}`, {
            method: "PATCH",
            body: JSON.stringify({
                text: text,
            }),
            headers: { "Content-Type": "application/json; charset=utf-8" },
        });
        const todo = await response.json();

        dispatch(edit(todo.id, todo.text));
    }
};

export default updateTodoText;